import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { isObservable } from 'rxjs';

@Component({
  selector: 'property-form-select',
  templateUrl: './select.component.html',
  imports: [FormlyModule, NgSelectModule, ReactiveFormsModule],
})
export class SelectComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  items: unknown[] = [];
  clearable = false;

  ngOnInit() {
    if (isObservable(this.props.options)) {
      this.props.options
        .subscribe((options) => {
          this.items = options;
        })
        .unsubscribe();
    } else {
      this.items = this.props.options || [];
    }
  }
}
